import { render, staticRenderFns } from "./alibabaProductModal.vue?vue&type=template&id=aea6e25c&scoped=true"
import script from "./alibabaProductModal.vue?vue&type=script&lang=js"
export * from "./alibabaProductModal.vue?vue&type=script&lang=js"
import style0 from "./alibabaProductModal.vue?vue&type=style&index=0&id=aea6e25c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea6e25c",
  null
  
)

export default component.exports